module.exports = __webpack_public_path__ + "static/media/fans.0326eb0f.jpg";